import React, { useEffect } from "react";
import { Row, Col, DropdownButton, Dropdown } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import QuestionOptInputText from './QuestionInputs/text';
// import QuestionOptInputTextarea from './QuestionInputs/textarea';
import QuestionOptInputImage from './QuestionInputs/image';
// import QuestionOptInputExternalVideo from './QuestionInputs/video_external';
// import QuestionOptInputEmbedVideo from './QuestionInputs/video_embed';
import { useMappedState, useDispatch } from 'redux-react-hook';

const E_OPT_TYPE = {
    0: "文字",
    1: "數字",
    // 2: "圖片",
    // 3: "影音" //"外部影音" "嵌入式影音??"
}
const E_OPT_TYPE_KEY = {
    TEXT: 0,
    DIGIT: 1,
    // IMAGE: 2,
    // VIDEO: 3
}
export default function QuestionOptOpen(props) {
    const tmpItems = useMappedState(state => state.tmpItems);
    const questionIndex = props.questionID;
    const optIndex = props.optIndex;
    const pid = useMappedState(state => state.pid);

    // console.log(props);
    // return <div>aa</div>;
    const data = (tmpItems && tmpItems.length > questionIndex
        && null != tmpItems[questionIndex]
        && null != tmpItems[questionIndex].op
        && tmpItems[questionIndex].op.length > optIndex)
        ? tmpItems[questionIndex].op[optIndex] : null;
    const dispatch = useDispatch();

    // useEffect(() => {
    //   console.log(tmpItems);
    // });

    function onOptChange(e) {
        console.log("onOptChange", e);

        let tmp = [...tmpItems];
        tmp[questionIndex].op[optIndex].na = e.target.value;
        // console.log(tmp);
        // setTmpItems(tmp);
        dispatch({ type: "UPDATE_TMP_ITEM", data: tmp });
        // props.onOptChange(props.index, optIndex, optVal);
    }

    function onOptKeyChange(key, val) {
        console.log("onOptKeyChange", val);
        try {
            let tmp = [...tmpItems];
            tmp[questionIndex].op[optIndex][key] = val;
            dispatch({ type: "UPDATE_TMP_ITEM", data: tmp });
        } catch (e) {
            console.warn("[onOptKeyChange]", e.stack);
        }
    }

    function onSelect(e) {
        console.log(e);
        if (e != props.o_type) {
            let tmpType = parseInt(e);
            if (isNaN(tmpType) == false) {
                // console.log(onOptChange);

                let tmp = [...tmpItems];
                tmp[questionIndex].op[optIndex].o_type = tmpType;
                // console.log(tmp);
                // setTmpItems(tmp);
                dispatch({ type: "UPDATE_TMP_ITEM", data: tmp });
            }
        }
    }

    function render() {
        if (data == null) return (<div>No Data</div>);

        var opts = Object.keys(E_OPT_TYPE).map(function (key) {
            return <Dropdown.Item key={key} eventKey={key}>{E_OPT_TYPE[key]}</Dropdown.Item>
        });

        let inputDom = (<QuestionOptInputText data={data.na} onChange={onOptChange} />);
        // let inputDom = null;
        // switch (data.o_type) {
        //     case E_OPT_TYPE_KEY.IMAGE: //圖片
        //         inputDom = (<QuestionOptInputImage index={questionIndex} data={data} onChange={onOptChange} onKeyChange={onOptKeyChange} pid={pid} />)
        //         break;
        // case 2: //外部影音(youtube)
        //     inputDom = (<QuestionOptInputExternalVideo index={questionIndex} data={data} onChange={onOptChange} onKeyChange={onOptKeyChange} pid={pid} />)
        //     break;
        // case 3: //嵌入式影音
        //     inputDom = (<QuestionOptInputEmbedVideo data={data} onChange={onOptChange} onKeyChange={onOptKeyChange} pid={pid} />)
        //     break;
        // case E_OPT_TYPE_KEY.TEXT: //文字
        // default:
        // inputDom = (<QuestionOptInputTextarea data={data.na} onChange={onOptChange} />)
        //         break;
        // }

        return (
            <Row>
                <Col xs={1}>
                    {/* {optIndex + 1} */}
                </Col>
                <Col className="text-left">
                    {inputDom}
                </Col>
                <Col xs={4} sm={3} lg={2} xl={1} className="text-left pb-1">
                    <DropdownButton
                        className="btn-block no-bg text-left w-100"
                        alignleft="true"
                        size="sm"
                        variant="success"
                        title={E_OPT_TYPE[data.o_type]}
                        onSelect={onSelect}
                    >
                        {opts}
                    </DropdownButton>
                </Col>
                <Col xs={1} className="text-right"><X onClick={props.onDelete} /></Col>
            </Row>
        );
    }

    return render();
}
